/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Stephan JAMBOU
 * @date        11/09/2020 11:33
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (https://www.iris-interactive.fr)
 * @package     SampledefaultTheme
 */

import 'slick-carousel/slick/slick.min';

export default class Slider {

    constructor()
    {
        Slider.initialize_front_slider();
        Slider.initialize_related_post();
        Slider.initialize_agenda_slider();
    }

    static initialize_front_slider() {

        const $sliders = $('[data-trigger="slider-front"]');

        const settings = {
            accessibility: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: true,
            variableWidth: false,
            centerMode: false,
            fade: true,
            pauseOnHover: false,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                }
            ]
        };
        $sliders.slick(settings);
    }


    static initialize_related_post()
    {
        const $sliders = $('[data-slider="related-post"]');

        const settings = {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
            ]
        };
        $sliders.slick(settings);
    }

    static initialize_agenda_slider() {

        const $sliders = $('[data-trigger="slider-agenda"]');

        const settings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            variableWidth: false,
            centerMode: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
        };
        $sliders.slick(settings);
    }
}
